module.exports = __webpack_public_path__ + "images/logo-color.160a43ec905fa05045ec415bb2e996a5.png";